import {Component, OnDestroy, OnInit} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {FileManagementService} from '@core/services/file-management.service';
import {DownloadSummaryRuleCommand} from '../../commands/dac6-reporter.command';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {select, Store} from "@ngrx/store";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {takeUntil} from "rxjs/operators";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'particle-summary-rules-content',
  templateUrl: './summary-rules-content.component.html',
  styleUrls: ['./summary-rules-content.component.scss']
})
export class SummaryRulesContentComponent implements OnInit, OnDestroy {

  sourceType: string;
  invalidateSubject: InvalidateSubject;
  demoHistory$: any;
  demoHistory: any;
  unsubscribe$ = new Subject<void>();
  disabledExport: boolean = false;

  constructor(private commandService: CommandService,
              private queryStore: Store<IQueryState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService) {
    this.sourceType = 'Dac6SummaryRule';
    this.invalidateSubject = new InvalidateSubject();
    this.disabledExport = false;
  }

  ngOnInit() {
    this.demoHistory$ = this.queryStore.pipe(select(getQueryResponse, 'MyDemo'), takeUntil(this.unsubscribe$));
    this.demoHistory$.subscribe(state => {
      this.demoHistory = state;
      if (this.demoHistory) {
        this.disabledExport = true;
      } else {
        this.disabledExport = false;
      }
    });
  }

  exportSummaryRule() {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new DownloadSummaryRuleCommand()).subscribe(response => {
      this.fileManagementService.downloadOneTimeSignedUrl(response.Payload.DownloadUrl, response.Payload.FileName);
      this.fuseSplashScreenService.hide();
    }, error => {
      this.fuseSplashScreenService.hide();
    });
  }

  onGridCellValueChange(event) {

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
